<div class="card bcx-card p-4 mb-4">

  <!-- HEADER -->
  <h6 class="card-title fw-bold text-xs mb-3 d-flex align-items-center gap-2">
    <i class="bi bi-calendar-week text-danger fs-6"></i>
    Today's Shift Schedule
  </h6>

  <!-- EMPTY STATE -->
  <div
    v-if="!has_shifts"
    class="text-center py-3 text-secondary text-xs"
  >
    No shift data available.
  </div>

  <!-- SHIFT LIST -->
  <ul v-else class="list-group list-group-flush">

    <li
      v-for="(shift, index) in shifts"
      :key="index"
      class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center"
    >

      <!-- LEFT: ROLE + TIME -->
      <div>
        <p class="fw-semibold text-xs mb-1">
          {{ shift.role }}
        </p>
        <p class="text-secondary text-xxs mb-0">
          <i class="bi bi-clock me-1"></i>
          {{ shift.time }}
        </p>
      </div>

      <!-- RIGHT: PERSONNEL COUNTER -->
      <div>
        <span class="badge rounded-pill bg-danger bg-opacity-10 text-danger text-xxs px-3 py-2">
          <i class="bi bi-people-fill me-1"></i>
          {{ shift.personnel }}
        </span>
      </div>

    </li>

  </ul>

</div>
